<div class="modal-header">
  <div class="modal-title f-20">
    <!-- {{ isCreate ? "New item" : "Edit Item" }} -->
    <h3>{{ isCreate ? "New Risk Details" : "Edit Risk Details" }}</h3>
  </div>
  <button class="fa fa-times" [mat-dialog-close]=""
    style="float: right; cursor: pointer; background: none; border: none" aria-hidden="true"
    (click)="closeAction()"></button>
</div>
<div class="modal-body risk-modal-body">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-3 mt-2 col-md-4 col-20">
          <label class="control-label">Risk Area
            <!-- <span class="stars">*</span> -->
          </label>
          <mat-select class="select_border_t3" [(ngModel)]="riskControl.riskArea">
            <mat-option *ngFor="
            let option of riskAreaList
          " [value]="option.item">
              {{ option.item }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-lg-3 mt-2 col-md-4 col-20">
          <label class="control-label">
            Compliance Topic</label>
          <mat-select class="select_border_t3" [(ngModel)]="riskControl.complianceTopic">
            <mat-option *ngFor="
            let option of complianceTopicList
          " [value]="option.item">
              {{ option.item }}
            </mat-option>
          </mat-select>

        </div>
        <div class="col-lg-3 mt-2 col-md-4 col-20">
          <label class="control-label">
            Risk Category </label>
          <mat-select class="select_border_t3" [(ngModel)]="riskControl.riskCategory">
            <mat-option *ngFor="
              let option of riskCategoryList
            " [value]="option.item">
              {{ option.item }}
            </mat-option>
          </mat-select>

        </div>
        <div class="col-lg-3 mt-2 col-md-4 col-20">
          <label class="control-label">
            Risk Title</label>
          <mat-select class="select_border_t3" [(ngModel)]="riskControl.riskTitle">
            <mat-option *ngFor="
            let option of riskTitleList
          " [value]="option.item">
              {{ option.item }}
            </mat-option>
          </mat-select>

        </div>

        <div class="col-lg-6 mt-4 col-md-6">
          <label class="control-label">Description</label>
          <textarea class="risk_textarea" [(ngModel)]="riskControl.riskDescription"></textarea>
        </div>

        <div class="col-lg-6 mt-4 col-md-6">
          <label class="control-label">
            Entities Impacted</label>

          <mat-chip-grid class="t3_matchip" #entitesImpactedInputList>
            <ng-container *ngFor="let item of entitieImpactedDD">
              <mat-chip-row [selectable]="true" [removable]="true" (removed)="removeEntitesImpacted(item)"
                class="mat-chip-category">
                {{ item }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
            </ng-container>
            <input class="form-control form-control-sm mat-autodd-input border-bottom" #entityImpacted
              [formControl]="searchentitesImpactedCntrl" [matAutocomplete]="entitesImpactedAutoComplete"
              [matChipInputFor]="entitesImpactedInputList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true" autocomplete="off" (matChipInputTokenEnd)="addentitesImpacted($event)"
              #entitesImpactedAutoTrigger="matAutocompleteTrigger"
              placeholder="Type to filter or add Entites Impacted" />
          </mat-chip-grid>
          <mat-autocomplete #entitesImpactedAutoComplete="matAutocomplete"
            (optionSelected)="selectedEntitesImpactedEvent($event)">
            <mat-option *ngFor="
          let option of entitiesImpactedList
        " [value]="option.item">
              {{ option.item }}
            </mat-option>
          </mat-autocomplete>


          <!-- <mat-select class="select_border_t3" [(ngModel)]="riskControl.entitiesImpacted">
          <mat-option *ngFor="
              let option of entitiesImpactedList
            " [value]="option.item">
            {{ option.item }}
          </mat-option>
        </mat-select> -->

        </div>
        <div class="col-lg-6 mt-4 col-md-6">
          <label class="control-label">
            Applicable Rules</label>


        </div>
      </div>
      <div class="tab_risk mt-3">
        <div class="d-flex w-100 align-items-center gap-2 justify-content-between text-header">
          <ul class="nav template3_nav add_editRisk nav-tabs border-0">
            <li>
              <a class="nav-link" (click)="openOwnersANDStatus()" [ngClass]="showOwnersANDStatus ? 'active' : ''">Owners
                &
                Status</a>
            </li>

            <li>
              <a class="nav-link" (click)="OpenshowRiskScoring()" [ngClass]="showRiskScoring ? 'active' : ''">Risk
                Scoring</a>
            </li>

            <li>
              <a class="nav-link" (click)="OpenControl()" [ngClass]="showControl? 'active' : ''">Controls </a>
            </li>
            <li>
              <a class="nav-link" (click)="openComments()" [ngClass]="showComments? 'active' : ''">Comments </a>
            </li>
          </ul>

        </div>
        <div class="tab_risk_content mt-3">

          <div class=" row" *ngIf="showOwnersANDStatus">
            <div class="col-lg-3 mt-2 col-md-4 col-20">
              <label class="control-label">
                Risk Owner</label>
              <mat-select class="select_border_t3" [(ngModel)]="riskControl.riskOwner">
                <mat-option *ngFor="
                let option of riskOwnerList
              " [value]="option.item">
                  {{ option.item }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-3 mt-2 col-md-4 col-20">
              <label class="control-label">
                Risk Accountability Owner</label>
              <mat-select class="select_border_t3" [(ngModel)]="riskControl.riskAccountabilityOwner">
                <mat-option *ngFor="
                let option of riskAccountabilityOwnerList
              " [value]="option.item">
                  {{ option.item }}
                </mat-option>
              </mat-select>

            </div>
            <div class="col-lg-3 mt-2 col-md-4 col-20">
              <label class="control-label">
                Date Created</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="dateCreated" (click)="dateCreated.open()"
                  class="form-control form-control-sm border-bottom" name="dateCreated"
                  [(ngModel)]="riskControl.dateCreated" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="dateCreated.open()"></span>
                </div>
              </div>
              <mat-datepicker #dateCreated></mat-datepicker>

            </div>
            <div class="col-lg-3 mt-2 col-md-4 col-20">
              <label class="control-label">
                Effective Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="effectiveDate" (click)="effectiveDate.open()"
                  class="form-control form-control-sm border-bottom" name="effectiveDate"
                  [(ngModel)]="riskControl.effectiveDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="effectiveDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #effectiveDate></mat-datepicker>

            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label">
                Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="lastEdited" (click)="lastEdited.open()"
                  class="form-control form-control-sm border-bottom" name="lastEdited"
                  [(ngModel)]="riskControl.lastEdited" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="lastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #lastEdited></mat-datepicker>

            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label">
                Risk Approver</label>
              <mat-select class="select_border_t3" [(ngModel)]="riskControl.riskApprover">
                <mat-option *ngFor="
                  let option of riskApproverList
                " [value]="option.item">
                  {{ option.item }}
                </mat-option>
              </mat-select>

            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label">
                Approval Status</label>
              <mat-select class="select_border_t3" [(ngModel)]="riskControl.approvalStatus">
                <mat-option *ngFor="
                  let option of approvalStatusList
                " [value]="option.item">
                  {{ option.item }}
                </mat-option>
              </mat-select>


            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label">
                Risk Status</label>
              <mat-select class="select_border_t3" [(ngModel)]="riskControl.riskStatus">
                <mat-option *ngFor="
                  let option of riskStatusList
                " [value]="option.item">
                  {{ option.item }}
                </mat-option>
              </mat-select>

            </div>
          </div>

          <div class="row" *ngIf="showRiskScoring">
            <div class="col-lg-4 mt-2 col-md-4">
              <label class="control-label">
                Risk Scoring</label>
              <input class="risk_input" [(ngModel)]="riskControl.harmToFirmsViability" type="text" />
            </div>
            <div class="col-lg-4 mt-2 col-md-4">
              <label class="control-label">
                Harm to Client</label>
              <input class="risk_input" [(ngModel)]="riskControl.harmToClient" type="text" />

            </div>
            <div class="col-lg-4 mt-2 col-md-4">
              <label class="control-label">
                Harm to Market</label>
              <input class="risk_input" [(ngModel)]="riskControl.harmToMarket" type="text" />

            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label">
                Inherent Risk - Likelihood</label>
              <mat-select class="select_border_t3"
                (selectionChange)="onRiskLikelihood(riskControl.inherentRiskLikelihood)"
                [(ngModel)]="riskControl.inherentRiskLikelihood">
                <mat-option *ngFor="
                  let option of inherentRiskLikelihoodList
                " [value]="option.item">
                  {{ option.item }}
                </mat-option>
              </mat-select>

            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label">
                Inherent Risk - Impact</label>
              <mat-select (selectionChange)="onRiskImpact(riskControl.inherentRiskImpact)" class="select_border_t3"
                [(ngModel)]="riskControl.inherentRiskImpact">
                <mat-option *ngFor="
                  let option of inherentRiskImpactList
                " [value]="option.item">
                  {{ option.item }}
                </mat-option>
              </mat-select>

            </div>
            <div class="col-lg-3 mt-4 risk_tag col-md-4 col-20">
              <label class="control-label">
                Inherent Risk - Rating:</label>
              <span class="label label-default bg-none p5-20" *ngIf="riskControl.inherentRiskRating ==='' ">None</span>
              <span class="label label-default bg-veryHigh p5-20" *ngIf="riskControl.inherentRiskRating === 'Very High'">Very
                High</span>
              <span class="label ml-2 label-default bg-high p5-20"
                *ngIf="riskControl.inherentRiskRating === 'High'">High</span>
              <span class="label ml-2 label-default bg-medium p5-20"
                *ngIf="riskControl.inherentRiskRating === 'Moderate'">Medium</span>
              <span class="label ml-2 label-default bg-low p5-20"
                *ngIf="riskControl.inherentRiskRating === 'Low'">Low</span>
              <span class="label ml-2 label-default bg-veryLow p5-20"
                *ngIf="riskControl.inherentRiskRating === 'Very Low'">Very
                Low</span>

            </div>
            <div class="col-lg-3 mt-4 col-md-4 col-20">
              <label class="control-label">
                Residual Risk - Control Strength</label>
              <mat-select (selectionChange)="onRiskControl(riskControl.residualRiskControlStrength)"
                class="select_border_t3" [(ngModel)]="riskControl.residualRiskControlStrength">
                <mat-option *ngFor="
                  let option of residualRiskControlStrength
                " [value]="option.item">
                  {{ option.item }}
                </mat-option>
              </mat-select>

            </div>
            <div class="col-lg-3 risk_tag mt-4 col-md-4">
              <label class="control-label">
                Residual Risk - Rating:</label>
              <span class="label label-default bg-none p5-20" *ngIf="riskControl.residualRiskRating ==='' ">None</span>
              <span class="label label-default bg-veryHigh p5-20" *ngIf="riskControl.residualRiskRating === 'Very High'">Very
                High</span>
              <span class="label ml-2 label-default bg-high p5-20"
                *ngIf="riskControl.residualRiskRating === 'High'">High</span>
              <span class="label ml-2 label-default bg-medium p5-20"
                *ngIf="riskControl.residualRiskRating === 'Moderate'">Medium</span>
              <span class="label ml-2 label-default bg-low p5-20"
                *ngIf="riskControl.residualRiskRating === 'Low'">Low</span>
              <span class="label ml-2 label-default bg-veryLow p5-20"
                *ngIf="riskControl.residualRiskRating === 'Very Low'">Very
                Low</span>

            </div>
            <div class="col-lg-3 mt-4 col-md-4">
              <label class="control-label">
                Residual Risk Rationale</label>
              <input class="risk_input" [(ngModel)]="riskControl.residualRiskRationale" type="text" />
            </div>
          </div>

          <div class="row" *ngIf="showControl">
            <div class="col-lg-3 mt-2 col-md-4">
              <label class="control-label">
                Controls</label>

            </div>


          </div>
          <div class="row" *ngIf="showComments">
            <div class="col-lg-6 mt-4 col-md-6">
              <label class="control-label">
                Comments and other Supplementary Information</label>
              <input class="risk_input" [(ngModel)]="riskControl.comments" type="text" />
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right bg-white">
      <button class="btn bg-g-lightGreen btn-sm mr-2" (click)="closeAction()">
        Cancel
      </button>
      <button class="btn bg-g-lightGreen btn-sm" (click)="updateRiskControl()">
        {{ isCreate ? "Save" : "Update" }}
      </button>
    
    </div>
  </div>
</div>